import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen flex items-center justify-center px-4 pt-20">
      <div className="text-center max-w-md">
        <XCircle size={56} className="text-slate-500 mx-auto mb-6" />
        <h1 className="font-display text-3xl font-black text-white mb-3">Payment cancelled</h1>
        <p className="text-slate-400 text-sm mb-8 leading-relaxed">
          No charge was made. Your booking request still stands — you can pay the
          deposit later via the link in your confirmation email, or pay by EFT.
        </p>
        <Link to="/vehicles" data-testid="payment-cancel-back" className="inline-block bg-[#F57C00] hover:bg-[#E67300] text-white font-bold px-8 py-4 rounded-md transition-colors">
          Back to vehicles
        </Link>
      </div>
    </div>
  );
}
